module.exports = __webpack_public_path__ + "static/img/task.5ec993a0.svg";